import { createRoot } from 'react-dom/client';

import { IPicsartToolPubSub } from '@picsart/miniapps-sdk/types/types';
import setupContext from './context';
import Wrappers from './Wrappers';
import App from './App';

const setup = ({
  containerId,
  setupTheming = true,
  pubsub,
}: {
  containerId: string;
  setupTheming?: boolean;
  pubsub?: IPicsartToolPubSub;
}) => {
  const container = document.getElementById(containerId);
  if (!container) {
    throw new Error(
      `[GenAI Studio] container element #${containerId} not found`
    );
  }

  const root = createRoot(container);
  setupContext({ pubsub });

  root.render(
    <Wrappers setupTheming={setupTheming}>
      <App />
    </Wrappers>
  );

  return {
    unmount: () => root.unmount(),
  };
};

export default setup;
